export default __webpack_public_path__ + "static/Gmail-6ec987510555b6e73915219005674655.png";